import { createSlice } from "@reduxjs/toolkit";
import {
	getSaveLater,
	setSaveLater,
	emptySaveLater,
} from "../../lib/useLocalStorageUser";

const saveLaterInfo = getSaveLater();

const SaveLaterSlice = createSlice({
	name: "save-later",
	initialState: {
		...saveLaterInfo,
		error: "",
		loadingSaveLater: false,
	},
	reducers: {
		getSaveLater_() {},
		setSaveLater_(state, action) {
			const saveLaterData = action.payload;
			const data = { ...state, ...saveLaterData };
			setSaveLater(data);
			return { ...data };
		},
		removeSaveLater_() {
			emptySaveLater();
			return null;
		},
		getSaveLaterFail_(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingSaveLater: false };
		},
	},
});

export const {
	getSaveLater_,
	setSaveLater_,
	removeSaveLater_,
	getSaveLaterFail_,
} = SaveLaterSlice.actions;

export default SaveLaterSlice.reducer;
